import React from "react";
import { useParams, Link } from "react-router-dom";
import "./travel_detail.css"; // vagy "./travel.css" – ahol a hero stílus lesz
import { Footer } from "../footer/footer";
import { Gallery } from "./gallery";
import { useEffect, useState } from 'react';
import { BeatLoader } from "react-spinners";


const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date
    .toLocaleDateString('hu-HU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
    .replace(/\s+/g, ''); // eltávolítja a szóközöket
};


export function cleanUrl(url) {
  if (!url) return '';

  return url
    .replace(/[\n\r\t\u0000\u2028\u2029]+/g, '') // eltávolítja az összes rejtett karaktert (ENTER, tab, stb.)
    .trim(); // az elején és végén lévő szóközöket is eltávolítja
}




export function TravelDetail() {
  // Kinyerjük az ID paramétert (pl. /travel/2)
  const { id } = useParams();

  const [travel, setTravel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [travelImages, setTravelImages] = useState([]);


  // Megkeressük a megfelelő utazást
  useEffect(() => {
    async function fetchTravel() {
      try {
        // Feltételezzük, hogy a backend fut és elérhető pl. http://localhost:5000
        const response = await fetch(`/api/utazasok/${id}`);
        if (!response.ok) {
          throw new Error('Hiba történt az adatok lekérése során.');
        }
        const data = await response.json();
        setTravel(data);
        const t_images = [];
        for (let i = 0; i < data.images.length; i++) {
          t_images.push(data.images[i].picture_url);
        }
        setTravelImages(t_images);
        console.log("travel",data);
        console.log("travle images",t_images);
        
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchTravel();
    
  }, [id]);

  if (loading) {
    return <div className="loader-container">
      
      <BeatLoader  
    color={"#001662"}
    loading={loading}
    size={30}
    aria-label="Loading Spinner"
    data-testid="loader" />

    </div>;
  }

  if (error) {
    return <div>Hiba: {error}</div>;
  }


  return (
    <>
    <div className="travel-detail">
      {/* HERO háttér, overlay */}
      <div
  className="travel-detail-hero"
  style={{ backgroundImage: travel?.background_picture ? `url(${cleanUrl(travel.background_picture)})` : 'none' }}
>

        <div className="travel-detail-hero-overlay">
          <h1 className="travel-title">{travel.title}</h1>

        <div className="travel-detail-hero-text">
         {/* Dátum "buborék" */}
        
         <p className="travel-date-bubble">{formatDate(travel.tol) === formatDate(travel.ig) 
    ? formatDate(travel.tol) 
    : `${formatDate(travel.tol)} - ${formatDate(travel.ig)}`}</p>
 

          {/* Fizetési opciók */}
          <div className="payment-options">
           
            </div>
        </div>
          {/* Jelentkezés gomb */}
         
        </div>
      </div>
      <div className="travel-detail-jelentkezes">
      <Link to={`/apply/${travel.id}`} className="apply-btn">
            Jelentkezem!
          </Link>
      </div>

      {/* TARTALMI RÉSZ – kéthasábos elrendezés */}
      <div className="travel-detail-content">
        {/* Bal hasáb: paraméterek */}
        <div className="travel-info-left">
          <div className="travel-price-container">
            <p>Ár:</p>
            <div className="travel-price">{travel.price}</div>
          </div>
        </div>

        {/* Jobb hasáb: leírás */}
        <div className="travel-info-right">
          <h3>Leírás</h3>
          <div className="travel-info" dangerouslySetInnerHTML={{ __html: travel.description }}></div>
        </div>
      </div>
    </div>
      {/* Képgaléria */}
      <div className="travel-gallery">
        <Gallery images={travelImages} />
      </div>
    <Footer />
    
    </>
  );
}
